import { Injectable } from '@angular/core';

import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { Empty, MainApi } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GRpcRequestType } from '../grpc-class.type';
import { GrpcCommonService } from './common.service';

export type IGetToken = GRpcRequestType<MainApi.AuthV2GrpcWebContractClient['GetToken']>;
export type ILogin = GRpcRequestType<MainApi.AuthV2GrpcWebContractClient['Login']>;
export type IConfirmCodeLogin = GRpcRequestType<MainApi.AuthV2GrpcWebContractClient['ConfirmCodeLogin']>;

@Injectable()
export class AuthV2GrpcContractService extends GrpcCommonService<MainApi.AuthV2GrpcWebContractClient> {
  constructor(protected _GrpcContract: MainApi.AuthV2GrpcWebContractClient) {
    super();
  }

  getToken(request: IGetToken) {
    return from(
      this._GrpcContract.GetToken(
        new MainApi.WebRequest_String(MainApi.WebRequest_String.fromObject(request)),
        this.getMetadata(),
      ),
    ).pipe(grpcOperator());
  }

  /** Send a one-time confirmation code to the given email/phone (login email step, Figma 4481-9758). */
  login(request: ILogin) {
    return from(
      this._GrpcContract.Login(
        new MainApi.LoginV2WpcRequest(MainApi.LoginV2WpcRequest.fromObject(request)),
        this.getMetadata(),
      ),
    ).pipe(grpcOperator());
  }

  /** Confirm the code; the response carries the auth Token to swap in (Figma 4481-9924). */
  confirmCodeLogin(request: IConfirmCodeLogin) {
    return from(
      this._GrpcContract.ConfirmCodeLogin(
        new MainApi.LoginV2WpcRequest(MainApi.LoginV2WpcRequest.fromObject(request)),
        this.getMetadata(),
      ),
    ).pipe(grpcOperator());
  }

  userIsReal() {
    return from(this._GrpcContract.UserIsReal(new Empty(), this.getMetadata())).pipe(grpcOperator());
  }
}
